<template>
  <div id="app">
    <!-- <img id="example" src="./assets/example.png" /> -->

    <app-nav v-if="loaded" />
    <section-hero v-if="loaded"  />
    <section-stable v-if="loaded"  />
    <section-borrow v-if="loaded"  />
    <section-earn v-if="loaded"  />
    <section-govern v-if="loaded"  />
    <section-achitecture v-if="loaded"  />
<!--    <section-sponser v-if="loaded" />-->
    <section-audit v-if="loaded" />
    <app-footer v-if="loaded"  />

    <div v-if="showLoader" class="loader" :class="loaded ? 'loaded': '' ">
      {{imgLoaded ? 'imageloaded' : 'image not loaded'}}<br/>
      {{fontLoaded ? 'fontloaded' : 'font not loaded'}}
    </div>
  </div>
</template>

<script>
import AppNav from './components/AppNav';
import AppFooter from './components/AppFooter';
import SectionAchitecture from './components/SectionAchitecture.vue';
import SectionBorrow from './components/SectionBorrow.vue';
import SectionEarn from './components/SectionEarn.vue';
import SectionGovern from './components/SectionGovern.vue';
import SectionHero from './components/SectionHero.vue';
import SectionSponser from './components/SectionSponser.vue';
import SectionStable from './components/SectionStable.vue';
import SectionAudit from './components/SectionAudit.vue';

export default {
  components: {
    SectionHero,
    SectionStable,
    SectionBorrow,
    AppNav,
    AppFooter,
    SectionEarn,
    SectionGovern,
    SectionAchitecture,
    SectionSponser,
    SectionAudit,
  },
  name: 'App',
  data() {
    return {
      imgLoaded: false,
      fontLoaded: false,
      showLoader: true,
    };
  },
  computed: {
    loaded() {
      return this.imgLoaded && this.fontLoaded;
    }
  },
  created() {
    this.$translateManager.init();

    const loaded = () => {
      document.body.classList.add('loaded');
      setTimeout(() => {
        this.showLoader = false;
      }, 300);
    }

    document.fonts.ready.then((e) => {
      console.log(e);
      this.fontLoaded = true;
      if (this.imgLoaded)
        loaded();
    });

    const img = new Image();
    img.src = require("./assets/pattern.png");
    img.onload = () => {
      this.imgLoaded = true;
      if (this.fontLoaded)
        loaded();
    }
  }
}
</script>

<style>
@import url("./reset.css");

@font-face {
  font-family: Recoleta;
  font-weight: 400;
  font-display: block;
  src: url("assets/Recoleta-Regular.woff2")
}

@font-face {
  font-family: Recoleta;
  font-weight: 600;
  font-display: block;
  src: url("assets/Recoleta-SemiBold.woff2")
}

@font-face {
  font-family: Recoleta;
  font-weight: 700;
  font-display: block;
  src: url("assets/Recoleta-Bold.woff2")
}

@font-face {
  font-family: Recoleta;
  font-weight: 800;
  font-display: block;
  src: url("assets/Recoleta-Black.woff2")
}

:root {
  --text-default: #000;
  --primary: #7000ff;
  --secondary: #aa67ff;

  --nav: #fafbfb;
  --nav-link-inactive: #b2b3b3;
  --nav-link-active: #000;

  --surface: #fff;
}

a {
  text-decoration: inherit;
}

button {
  font-family: inherit;
  background: inherit;
  cursor: pointer;
  border: 0;
}

body {
  position: relative;
  min-height: 100%;
  background-color: #FFFBF2;
  background-size: 1440px 1026px;
  background-image: url('assets/pattern.png');
  background-blend-mode: multiply;
  color: var(--text-default);
  font-family: Recoleta, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* background: #fdf226; */
  overflow: hidden;

  &.loaded {
    /* background: #f7f7fa; */
    overflow-x: hidden;
    overflow-y: auto;
  }
}

#app {
  overflow-x: hidden;
  overflow-y: auto;
}

html {
  height: 100%;
  font-size: min(10px, 1.1vw);
}

@media (max-width: 425px) {
  html {
    font-size: min(10px, 3vw);
  }
}

#example {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.5;
  opacity: 0;
  z-index: 1;
}

.loader {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  overflow: hidden;
  color: transparent;
  background: #FFF42D;
  transition: background 0.3s;

  &.loaded {
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue